import { path } from 'd3-path'
import pointer from './helpers/pointer.js'
import Symbol2d from '../2d.js'
import tipLock from './helpers/tip-lock.js'

export default class DoubleBoxArrow extends Symbol2d {

  static mixins = [tipLock]

  handles = [{
    // first handle: x controls the arrow height, y controls the arrow width
    defaults: [0.83, 0.38],
    constraints: (dimensions, handles) => {
      const minX = handles[1].coords[0]
      const minY = .25
      return [
        [minX, 1], [minY, .5]
      ]
    },
    cursor: 'all-scroll',
  }, {
    // second handle: x controls the box width
    defaults: [0.73, null],
    constraints: (dimensions, handles) => {
      // The max x value cannot exceed handles[0].coords[0]
      const maxX = handles[0].coords[0]
      return [
        [.5, maxX], null
      ]
    },
    cursor: 'ew-resize',
  }]

  getHandles (dimensions) {
    let handles = this._getDefaultHandles()

    // The 2nd handle that controls the box width `y` value will always be
    // equal to the first value `y`, which controls the arrow width.
    handles[1].coords[1] = handles[0].coords[1]
    return [
      handles[0],
      handles[1]
    ].map(handle => this.enforceConstraints(handle, dimensions, handles))
  }

  path (dimensions, handles) {
    const _path = path()
    const _pointer = pointer(_path, dimensions, handles[0])
    const halfBox = (handles[1][0] * dimensions.width - dimensions.center[0])

    _path.moveTo(dimensions.center[0], 0)
    _path.lineTo(dimensions.center[0] + halfBox, 0)

    // Draw the east pointer
    _pointer([dimensions.center[0] + halfBox, dimensions.center[1] - _pointer.width / 2], 'east')

    _path.lineTo(dimensions.center[0] + halfBox, dimensions.height)
    _path.lineTo(dimensions.center[0] - halfBox, dimensions.height)

    // West pointer
    _pointer([dimensions.center[0] - halfBox, dimensions.center[1] + _pointer.width / 2], 'west')
    _path.lineTo(dimensions.center[0] - halfBox, 0)
    _path.closePath()

    return _path.toString()
  }

  textContainer (dimensions, handles) {
    const width = (handles[1][0] * dimensions.width - dimensions.center[0]) * 2

    return {
      center: dimensions.center,
      width,
      height: dimensions.height
    }
  }

}
